// extracted by mini-css-extract-plugin
module.exports = {"container":"IndustryItem_container__mz_0e","title":"IndustryItem_title__9kRNE"};